import React from 'react';
import HeaderComponent from "./Header";
import Products from "./Products";
import Profile from "./Profile";
import Stock from "./Stock";
import Machines from "./Machines";
import {useUser} from "./UserProvider";
import {Routes , Route} from "react-router-dom";
import {ProtectedRoutes} from "../Public/ProtectedRoutes";
import MachinesDetails from "./MachinesDetails";
import ProductsDetails from "./ProductsDetails";
import Positions from "./Positions";
import StockDetails from "./StockDetails";
import StockList from "./StockList";
import StockAssign from "./StockAssign";
import StockEdit from "./StockEdit";
import Transactions from "./Transactions";

export const Dashboard = () => {
    const {user} = useUser();
    const[menu, setMenu] = React.useState("profile");
    const render = {
        "profile": <Profile user={user} new={false}/>,
        "products": <Products />,
        "stock": <Stock />,
        "machines": <Machines />,
        "transactions": <Transactions />,
    }
    return(
        <>
            <HeaderComponent setRender={setMenu}/>
            <div className="container">
                <Routes>
                    <Route path="/" element={render[menu]} />
                    <Route element={<ProtectedRoutes redirectTo="/login" isAllowed={user !== undefined}/>}>
                        <Route path="/machine-details" element={<MachinesDetails />}></Route>
                        <Route path="/products-details" element={<ProductsDetails />}></Route>
                        <Route path="/positions-details" element={<Positions />}></Route>
                        <Route path="/stock-details" element={<StockDetails />}></Route>
                        <Route path="/stock-list" element={<StockList />}></Route>
                        <Route path="/stock-assign" element={<StockAssign />}></Route>
                        <Route path="/stock-edition" element={<StockEdit />}></Route>
                    </Route>
                </Routes>
            </div>
        </>
    )
}